// @flow
/* ***************************************************************************
* @author mfranco (mfranco@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import style from "./style.css"
import Division from "../../components/Division"
import Dialog from "react-toolbox/lib/dialog"
import Input from "react-toolbox/lib/input"
import Button from "react-toolbox/lib/button"
import DatePicker from "../../components/DatePicker"
import SimpleTable from "../SimpleTable"
import { toastr } from "react-redux-toastr"
import _ from "lodash"
import * as strings from "../../strings"
import {
  formatDate,
} from "../../utils"


const CONTACT_HISTORY_COLUMNS = {
  name: { title: strings.generalStrings.name, align: "left", width: "20%" },
  contactDate: { title: strings.paymentAgreements.contactDate, align: "left", width: "20%" },
  notes: { title: strings.generalStrings.details, align: "left", width: "auto" },
}


export default class DebtPhaseContactHistory extends Component {

  props: {
    newContactHistory: any,
    contactHistories: any,
    updateContactHistory: any,
    removeContactHistory: any,

    expanded?: boolean,
    onToggle?: () => any,
  }

  state = {
    createContact: false,
    editContact: false,
    idContact: undefined,
    idContactHistory: undefined,
    name: undefined,
    contactDate: new Date(),
    notes: undefined,
  }

  handleToggleVisible = () => {
    this.setState( {
      createContact: !this.state.createContact,
    } )
  }

  handleToggleEditVisible = () => {
    this.setState( {
      editContact: !this.state.editContact,
    } )
  }

  setUpContact = () => {
    const state = this.state
    return {
      contactDate: state.contactDate,
      notes: state.notes,
      contact: state.name,
    }
  }

  addContact = () => {
    let newContactHistory = this.setUpContact()
    this.handleToggleVisible()
    this.props.newContactHistory( newContactHistory )
      .then( () => toastr.success( strings.generalStrings.contactHistoryAdded ) )
      .catch( () => toastr.error( strings.generalStrings.errorAddingContactHistory ) )
  }

  removeContactHistory = () => {
    this.props.removeContactHistory( this.state.idContactHistory )
    this.handleToggleEditVisible()
  }

  renderContactDialog = ( submitFunction, title, active, toggleFunction, isAdd ) => {
    const actions = _.reject( [
      { label: strings.generalStrings.cancel, onClick: toggleFunction },

      ( !isAdd
        ? { label: strings.generalStrings.delete, onClick: this.removeContactHistory }
        : undefined ),

      { label: strings.generalStrings.submit, onClick: submitFunction },
    ], _.isUndefined )

    return (
      <Dialog
        className={style.dialogBox}
        actions={actions}
        active={active}
        onEscKeyDown={toggleFunction}
        onOverlayClick={toggleFunction}>
        <div className={style.blueBar}/>
        <Division title={title}/>
        <div className={style.inputsContainer}>
          <div className={style.rowInputs}>
            <Input
              type="text"
              label={strings.generalStrings.name}
              value={this.state.name}
              onChange={( event ) => this.setState( {
                name: event,
              } )}
            />
            <DatePicker
              label={strings.generalStrings.contactDate}
              value={ this.state.contactDate ? new Date( this.state.contactDate ) : undefined}
              onChange={( event ) => this.setState( {
                contactDate: event,
              } )}
            />
          </div>
          <div>
            <Input
              type="text"
              label={strings.generalStrings.details}
              multiline
              value={this.state.notes}
              onChange={( event ) => this.setState( {
                notes: event,
              } )}
            />
          </div>
        </div>
      </Dialog> )
  }

    openAddContact = () => {
      this.handleToggleVisible()
      this.setState( {
        name: undefined,
        contactDate: new Date(),
        notes: undefined,
      } )
    }

    openEditContact = ( contactHistory ) => () => {
      this.handleToggleEditVisible()
      this.setState( {
        name: contactHistory.contact,
        contactDate: contactHistory.contactDate,
        notes: contactHistory.notes,
        idContact: contactHistory.contact && contactHistory.contact.id,
        idContactHistory: contactHistory.id,
      } )
    }

    setUpContactHistoryEdit = () => {
      const state = this.state
      return {
        contactDate: state.contactDate,
        id: state.idContactHistory,
        notes: state.notes,
        contact: state.name,
      }
    }

    submitEditContact = () => {
      this.handleToggleEditVisible()
      const contactHistory = this.setUpContactHistoryEdit()
      this.props.updateContactHistory( contactHistory )
        .then( () => toastr.success( strings.generalStrings.contactHistorySaved ) )
        .catch( () => toastr.error( strings.generalStrings.errorSavingContactHistory ) )
    }

    render () {
      return (
        <div>
          {this.renderContactDialog(
            this.addContact,
            strings.contactHistory.addContact.toUpperCase(),
            this.state.createContact,
            this.handleToggleVisible,
            true,
          )}
          {this.renderContactDialog(
            this.submitEditContact,
            strings.contactHistory.editContact.toUpperCase(),
            this.state.editContact,
            this.handleToggleEditVisible,
            false,
          )}
          <SimpleTable
            columns={CONTACT_HISTORY_COLUMNS}
            dataFormatter={data => ({
              ...data,
              contactDate: formatDate( data.contactDate ),
            })}
            data={this.props.contactHistories.map( contactHistory => {
              return {
                ...contactHistory,
                name: _.get( contactHistory, "contact" ),
                _onClick: this.openEditContact( contactHistory ),
              }
            } )}
            style={{
              item: {  
                whiteSpace: "pre-wrap",
              }
            }}
          />
          <div className={style.buttonContainer}>
            <Button onClick={this.openAddContact} icon="add" raised primary>{strings.generalStrings.add}</Button>
          </div>
        </div>
      )
    }
}



// WEBPACK FOOTER //
// ./src/components/DebtPhaseContactHistory/index.jsx